var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-button row",on:{"click":function($event){_vm.GoToRoute()}}},[_c('img',{attrs:{"src":_vm.arrowIcon}}),_c('span',[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []

export { render, staticRenderFns }